<template>
    <b-card
        title="Filtros"
    >
    <div class="card-text">
        <b-row>
            <b-col align-h="center" cols="12" md="4" lg="3">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectClient"
                />
            </b-col>
            <b-col cols="12" md="4" lg="3">
                <app-form-select-input 
                    placeholder="Tipo de Gestión"
                    v-model="filters.type"
                    :options="types"
                />
            </b-col>
            <b-col cols="12" md="4" lg="3">
                <app-form-text-input 
                    placeholder="Usuario que registra"
                    v-model="filters.userName"
                />
            </b-col>
            <b-col cols="12" md="4" lg="3">
                <app-form-text-input 
                    placeholder="Titulo"
                    v-model="filters.title"
                />
            </b-col>
            <b-col cols="12" md="2" lg="1" offset-lg="10">
                <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
            </b-col>
            <b-col cols="12" md="2" lg="1">
                <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </b-col>
        </b-row>
    </div>
    </b-card>
</template>
<script>
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    props: {
        types: {
            required: true
        }
    },
    data(){
        return {
            filters: {
                type: '',
                userName: '',
                title: '',
                client: ''
            },
            selectClient: ''
        }
    },
    watch: {
        selectClient(val){
            if(!val){
                this.filters.client= '';
                this.selectClient = '';
            }else{
                this.filters.client = val.id;
            }
        },
    },
    computed: {
        ...mapGetters(['clients'])
    },
    methods: {
        clearFilters(){
            this.selectClient= '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    },
    created(){
        this.load('clients');
    }
}
</script>